import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@/i18n';
import { ApiError } from '@/api/client';
import { AuthProvider } from '@/auth/AuthProvider';
import { App } from '@/App';
import { theme } from '@/theme';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            // One retry on network or server errors, none on 4xx (spec §7.3).
            retry: (failureCount, error) =>
                failureCount < 1 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
        },
    },
});

const root = document.getElementById('root');
if (!root) {
    throw new Error('index.html has no #root element');
}

createRoot(root).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </AuthProvider>
            </QueryClientProvider>
        </ThemeProvider>
    </StrictMode>,
);
